import { DataLayer } from "@sazka/utils/data-layer";

export default function useHcAnalytics() {
    const openAnalyticsChat = () => {
        DataLayer.push({
            event: "action.openChat.helpcenter",
        });
    };

    const selectAnalyticsTopic = (topicName: string) => {
        DataLayer.push({
            event: "action.selectTopic.helpcenter",
            action: {
                selectTopic: {
                    label: topicName,
                },
            },
        });
    };

    const selectAnalyticsCategory = (topicName: string, categoryName: string) => {
        DataLayer.push({
            event: "action.selectCategory.helpcenter",
            action: {
                selectCategory: {
                    label: topicName,
                    eventProperty1: categoryName,
                },
            },
        });
    };

    const selectAnalyticsQuestion = (topicName: string, categoryName: string, question: string) => {
        DataLayer.push({
            event: "action.selectQuestion.helpcenter",
            action: {
                selectQuestion: {
                    label: topicName,
                    eventProperty1: categoryName,
                    eventProperty2: question,
                },
            },
        });
    };

    return {
        openAnalyticsChat,
        selectAnalyticsTopic,
        selectAnalyticsCategory,
        selectAnalyticsQuestion,
    };
}
